export const LIST_EXAMINATION_ITEM_REQUEST = 'LIST_EXAMINATION_ITEM_REQUEST'
export const LIST_EXAMINATION_ITEM_SUCCESS = 'LIST_EXAMINATION_ITEM_SUCCESS'
export const LIST_EXAMINATION_ITEM_FAIL = 'LIST_EXAMINATION_ITEM_FAIL'
export const LIST_EXAMINATION_ITEM_RESET = 'EXAMINATION_ITEM_RESET'

export const POSITION_EXAMINATION_ITEM_REQUEST = 'POSITION_EXAMINATION_ITEM_REQUEST'
export const POSITION_EXAMINATION_ITEM_SUCCESS = 'POSITION_EXAMINATION_ITEM_SUCCESS'
export const POSITION_EXAMINATION_ITEM_FAIL = 'POSITION_EXAMINATION_ITEM_FAIL'

export const SUMMARY_EXAMINATION_ITEM_REQUEST = 'SUMMARY_EXAMINATION_ITEM_REQUEST'
export const SUMMARY_EXAMINATION_ITEM_SUCCESS = 'SUMMARY_EXAMINATION_ITEM_SUCCESS'
export const SUMMARY_EXAMINATION_ITEM_FAIL = 'SUMMARY_EXAMINATION_ITEM_FAIL'

export const CREATE_EXAMINATION_ITEM_REQUEST = 'CREATE_EXAMINATION_ITEM_REQUEST'
export const CREATE_EXAMINATION_ITEM_SUCCESS = 'CREATE_EXAMINATION_ITEM_SUCCESS'
export const CREATE_EXAMINATION_ITEM_FAIL = 'CREATE_EXAMINATION_ITEM_FAIL'

export const DETAIL_EXAMINATION_ITEM_REQUEST = 'DETAIL_EXAMINATION_ITEM_REQUEST'
export const DETAIL_EXAMINATION_ITEM_SUCCESS = 'DETAIL_EXAMINATION_ITEM_SUCCESS'
export const DETAIL_EXAMINATION_ITEM_FAIL = 'DETAIL_EXAMINATION_ITEM_FAIL'

export const UPDATE_EXAMINATION_ITEM_REQUEST = 'UPDATE_EXAMINATION_ITEM_REQUEST'
export const UPDATE_EXAMINATION_ITEM_SUCCESS = 'UPDATE_EXAMINATION_ITEM_SUCCESS'
export const UPDATE_EXAMINATION_ITEM_FAIL = 'UPDATE_EXAMINATION_ITEM_FAIL'

export const DELETE_EXAMINATION_ITEM_REQUEST = 'DELETE_EXAMINATION_ITEM_REQUEST'
export const DELETE_EXAMINATION_ITEM_SUCCESS = 'DELETE_EXAMINATION_ITEM_SUCCESS'
export const DELETE_EXAMINATION_ITEM_FAIL = 'DELETE_EXAMINATION_ITEM_FAIL'

export const LIST_KIT_VERSION_REQUEST = 'LIST_KIT_VERSION_REQUEST'
export const LIST_KIT_VERSION_SUCCESS = 'LIST_KIT_VERSION_SUCCESS'
export const LIST_KIT_VERSION_FAIL = 'LIST_KIT_VERSION_FAIL'

export const CREATE_KIT_VERSION_REQUEST = 'CREATE_KIT_VERSION_REQUEST'
export const CREATE_KIT_VERSION_SUCCESS = 'CREATE_KIT_VERSION_SUCCESS'
export const CREATE_KIT_VERSION_FAIL = 'CREATE_KIT_VERSION_FAIL'

export const DETAIL_KIT_VERSION_REQUEST = 'DETAIL_KIT_VERSION_REQUEST'
export const DETAIL_KIT_VERSION_SUCCESS = 'DETAIL_KIT_VERSION_SUCCESS'
export const DETAIL_KIT_VERSION_FAIL = 'DETAIL_KIT_VERSION_FAIL'

export const UPDATE_KIT_VERSION_REQUEST = 'UPDATE_KIT_VERSION_REQUEST'
export const UPDATE_KIT_VERSION_SUCCESS = 'UPDATE_KIT_VERSION_SUCCESS'
export const UPDATE_KIT_VERSION_FAIL = 'UPDATE_KIT_VERSION_FAIL'

export const UPDATE_KIT_VERSION_STATUS_REQUEST = 'UPDATE_KIT_VERSION_STATUS_REQUEST'
export const UPDATE_KIT_VERSION_STATUS_SUCCESS = 'UPDATE_KIT_VERSION_STATUS_SUCCESS'
export const UPDATE_KIT_VERSION_STATUS_FAIL = 'UPDATE_KIT_VERSION_STATUS_FAIL'

export const DELETE_KIT_VERSION_REQUEST = 'DELETE_KIT_VERSION_REQUEST'
export const DELETE_KIT_VERSION_SUCCESS = 'DELETE_KIT_VERSION_SUCCESS'
export const DELETE_KIT_VERSION_FAIL = 'DELETE_KIT_VERSION_FAIL'

export const LIST_NORMAL_VALUE_REQUEST = 'LIST_NORMAL_VALUE_REQUEST'
export const LIST_NORMAL_VALUE_SUCCESS = 'LIST_NORMAL_VALUE_SUCCESS'
export const LIST_NORMAL_VALUE_FAIL = 'LIST_NORMAL_VALUE_FAIL'

export const DELETE_NORMAL_VALUE_REQUEST = 'DELETE_NORMAL_VALUE_REQUEST'
export const DELETE_NORMAL_VALUE_SUCCESS = 'DELETE_NORMAL_VALUE_SUCCESS'
export const DELETE_NORMAL_VALUE_FAIL = 'DELETE_NORMAL_VALUE_FAIL'

export const UPDATE_NORMAL_VALUE_REQUEST = 'UPDATE_NORMAL_VALUE_REQUEST'
export const UPDATE_NORMAL_VALUE_SUCCESS = 'UPDATE_NORMAL_VALUE_SUCCESS'
export const UPDATE_NORMAL_VALUE_FAIL = 'UPDATE_NORMAL_VALUE_FAIL'

export const DETAIL_NORMAL_VALUE_REQUEST = 'DETAIL_NORMAL_VALUE_REQUEST'
export const DETAIL_NORMAL_VALUE_SUCCESS = 'DETAIL_NORMAL_VALUE_SUCCESS'
export const DETAIL_NORMAL_VALUE_FAIL = 'DETAIL_NORMAL_VALUE_FAIL'

export const DETAIL_NORMAL_VALUE_PRINTED_REQUEST = 'DETAIL_NORMAL_VALUE_PRINTED_REQUEST'
export const DETAIL_NORMAL_VALUE_PRINTED_SUCCESS = 'DETAIL_NORMAL_VALUE_PRINTED_SUCCESS'
export const DETAIL_NORMAL_VALUE_PRINTED_FAIL = 'DETAIL_NORMAL_VALUE_PRINTED_FAIL'

export const CREATE_NORMAL_VALUE_REQUEST = 'CREATE_NORMAL_VALUE_REQUEST'
export const CREATE_NORMAL_VALUE_SUCCESS = 'CREATE_NORMAL_VALUE_SUCCESS'
export const CREATE_NORMAL_VALUE_FAIL = 'CREATE_NORMAL_VALUE_FAIL'

export const EXPORT_EXAMINATION_ITEM_REQUEST = 'EXPORT_EXAMINATION_ITEM_REQUEST'
export const EXPORT_EXAMINATION_ITEM_SUCCESS = 'EXPORT_EXAMINATION_ITEM_SUCCESS'
export const EXPORT_EXAMINATION_ITEM_FAIL = 'EXPORT_EXAMINATION_ITEM_FAIL'
